import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WorkflowNavContainer from '../workflow-navigation/WorkflowNavContainer';

const propTypes = {
    workflowNavElementId: PropTypes.string,
    trustedDeviceName: PropTypes.string,
    secondaryButtonUrl: PropTypes.string
};

class AddTrustedDeviceContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: false,
            deviceName: this.props.trustedDeviceName
        };
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
        this.handleTrustedDeviceNameChange = this.handleTrustedDeviceNameChange.bind(this);
    }

    handleTrustedDeviceNameChange(event) {
        this.setState({ deviceName: event.target.value });
    }

    handleCheckBoxChange(event) {
        this.setState({ isChecked: event.target.checked });
    }

    isNextEnabled() {
        return this.state.isChecked;
    }

    render() {
        return (
            <div>
                <div className="asc-form-group">
                    <div className="text--center">
                        <div className="asc-checkbox-group">
                            <input
                                id="checkbox-trust-this-device"
                                type="checkbox"
                                onChange={this.handleCheckBoxChange}
                                name="checkbox-trust-this-device"
                            />
                            <label className="asc-form-label" htmlFor="checkbox-trust-this-device">
                                Yes, I want to make this device trusted
                            </label>
                        </div>
                    </div>

                    <label className="asc-form-label" htmlFor="name">
                        Give your device a name
                    </label>
                    <input
                        type="text"
                        name="name"
                        id="name"
                        value={this.state.deviceName}
                        onChange={this.handleTrustedDeviceNameChange}
                        required
                        placeholder="EX: My IPhone"
                        className="asc-form-input"
                        data-qa="name"
                    />
                </div>
                <WorkflowNavContainer
                    primaryButtonSubmitEnabled={this.isNextEnabled()}
                    primaryButtonText="Confirm"
                    elementId={this.props.workflowNavElementId}
                    secondaryButtonUrl={this.props.secondaryButtonUrl}
                    secondaryButtonText="Cancel"
                />
            </div>
        );
    }
}

AddTrustedDeviceContainer.propTypes = propTypes;
export default AddTrustedDeviceContainer;
